import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input, OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { AuthService } from '@app/auth/auth.service';
import { config } from '@app/app.config';
import { UsersService } from '@app/services/users.service';
import { ModalService } from '@app/shared/modal/modal.service';
import { UploadsService } from '@app/uploads/uploads.service';
import { SubmitUploadComponent } from '@app/uploads/submit-upload/submit-upload.component';
import { FileUpload } from 'primeng/fileupload';
import { EngineKeyToNameMap, EngineList } from '@app/shared/engine-list';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit, OnDestroy {

  baseURL = `${config.httpURL}`;
  @Output('success') success = new EventEmitter<any>();
  @Input() endpointPath: string;
  @Input() buttonText: string;
  @ViewChild('fileUpload') fileUpload: FileUpload;
  private interval: number;
  multipleSpeakers = false;
  engine: string = EngineList.Google;
  language: string;
  public engines;
  public files;

  private uploadOptions;

  constructor(
    private authService: AuthService,
    private modalService: ModalService,
    private usersService: UsersService,
    private uploadsService: UploadsService
    ) {
  }

  ngOnInit() {
    this.engines = [];
    this.files = [];
    this.usersService.getPermissions().subscribe(res => {
      res
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(permission => {
        const engine = EngineKeyToNameMap[permission.name];
        if (engine) {
          this.engines.push({ label: engine, value: engine });
        }
      })
    });

    if (this.engines.length > 0)
      this.engine = this.engines[0];
  }

  get endpoint() {
    return `${this.baseURL}${this.endpointPath}?multipleSpeakers=${this.multipleSpeakers}&engine=${this.getEngine()}&language=${this.language}`;
  }

  getEngine() {
    switch(this.engine){
      case EngineList.Google:
        return 'google';
      case EngineList.Watson:
        return 'watson';
      case EngineList.Whisper:
        return 'whisper';
      case EngineList.DeepGram:
        return 'deepgram';
      case EngineList.Transcribe:
        return 'transcribe';
    }
    return null;
  }

  getSaveHeaders(): HttpHeaders {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.authService.getAccessToken()}`
    });
    return headers;
  }

  public remove(upload, uid: string) {
    upload.removeFilesByUid(uid);
  }

  onUpload(queue) {
    clearInterval(this.interval);

    console.log(queue);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  uploadFiles(event) {
    this.modalService
      .show<SubmitUploadComponent>(SubmitUploadComponent, { data: event } )
      .afterClosed()
      .subscribe(res => {
        if (res === true)
          return;

        let parms = `&parms=`
        this.uploadsService.preUpload(event.files).subscribe(
          result => {
            parms += result.join(',');

            this.multipleSpeakers = res.multipleSpeakers;
            this.engine = res.engine;
            this.language = res.language;
            this.fileUpload.customUpload = false;
            this.fileUpload.url = this.endpoint + parms;
            this.fileUpload.upload();
            this.fileUpload.customUpload = true;
          }
        );
      });
  }
}
